import { render, staticRenderFns } from "./MediaButton.vue?vue&type=template&id=763e9146&scoped=true&"
import script from "./MediaButton.vue?vue&type=script&lang=js&"
export * from "./MediaButton.vue?vue&type=script&lang=js&"
import style0 from "./MediaButton.vue?vue&type=style&index=0&id=763e9146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763e9146",
  null
  
)

export default component.exports